import React from "react";
import Radio from "../../../../../shared/Radio/Radio";
import { MODALITY } from "../../consts";

const ModalityRadioSelector = props => {
	const handleChange = event => {
		props.onChange({ modality: event.value });
	};

	return (
		<div>
			<h5>Escolha a modalidade</h5>
			<Radio
				className="filter-type-sale"
				onChange={handleChange}
				options={[
					{
						label: "TODOS",
						value: MODALITY.ALL,
						checked: props.modality === MODALITY.ALL
					},
					{
						label: "CONVENCIONAL",
						value: MODALITY.CONVENTIONAL,
						checked: props.modality === MODALITY.CONVENTIONAL
					},
					{
						label: "AGENDADO",
						value: MODALITY.SCHEDULED,
						checked: props.modality === MODALITY.SCHEDULED
					}
				]}
			/>
		</div>
	);
};

export default ModalityRadioSelector;
